/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RescheduleLoanInput { 
    rescheduleDate?: string;
    tenure?: number;
    existingLoanOutstandingAmount?: number;
    additionalAmount?: number;
    newLoanPrincipalAmount?: number;
    disburseAmount?: number;
    loanId?: number;
    balanceCapitalizedTypeId?: number;
}

